export const numberAsStringField = (number: number | null): string =>
  number?.toString() || "";
